import { nebraskaSchemePlugin } from './nebraska-scheme';

export default nebraskaSchemePlugin;
